import ResourceLink from 'components/common/digitalResourcesMaps/resourceLink';
import React, { useCallback } from 'react';
import { IDResource, MapGroupProps } from 'types';
import { getPictureByUrl, onFaviconError } from 'utils/helpers/resourcesMap';

const ScienceLink: React.FC<MapGroupProps> = ({
  resources,
  onHoveredElementChanged,
  onClick,
}) => {
  const onElementHover = useCallback(
    (resource?: IDResource, target?: SVGElement) => {
      if (onHoveredElementChanged) {
        onHoveredElementChanged(resource, target);
      }
    },
    [onHoveredElementChanged]
  );

  const resource1SVGComponent = (
    <g
      className="icon-link"
      pointerEvents="none"
      transform="translate(0 0) rotate(-12)"
    >
      <rect
        x="0"
        y="0"
        width="67"
        height="67"
        rx="13.34"
        fill="#fff"
        stroke="#FFA511"
        strokeMiterlimit="10"
        strokeWidth="4"
      />
      <image
        width="54"
        height="54"
        transform="translate(6.5 6.5)"
        href={getPictureByUrl(resources[0]?.link)}
        onError={onFaviconError}
        pointerEvents="all"
      />
    </g>
  );

  const resource2SVGComponent = (
    <g
      className="icon-link"
      pointerEvents="none"
      transform="translate(90 -15) rotate(2)"
    >
      <rect
        x="0"
        y="0"
        width="67"
        height="67"
        rx="13.34"
        fill="#fff"
        stroke="#FFA511"
        strokeMiterlimit="10"
        strokeWidth="4"
      />
      <image
        width="54"
        height="54"
        transform="translate(6.5 6.5)"
        href={getPictureByUrl(resources[1]?.link)}
        onError={onFaviconError}
        pointerEvents="all"
      />
    </g>
  );

  const resource3SVGComponent = (
    <g
      className="icon-link"
      pointerEvents="none"
      transform="translate(180 -15) rotate(12)"
    >
      <rect
        x="0"
        y="0"
        width="67"
        height="67"
        rx="13.34"
        fill="#fff"
        stroke="#FFA511"
        strokeMiterlimit="10"
        strokeWidth="4"
      />
      <image
        width="54"
        height="54"
        transform="translate(6.5 6.5)"
        href={getPictureByUrl(resources[2]?.link)}
        onError={onFaviconError}
        pointerEvents="all"
      />
    </g>
  );

  const resource4SVGComponent = (
    <g
      className="icon-link"
      pointerEvents="none"
      transform="translate(0 -80) rotate(-8)"
    >
      <rect
        x="0"
        y="0"
        width="67"
        height="67"
        rx="13.34"
        fill="#fff"
        stroke="#FFA511"
        strokeMiterlimit="10"
        strokeWidth="4"
      />
      <image
        width="54"
        height="54"
        transform="translate(6.5 6.5)"
        href={getPictureByUrl(resources[3]?.link)}
        onError={onFaviconError}
        pointerEvents="all"
      />
    </g>
  );
  const resource5SVGComponent = (
    <g
      className="icon-link"
      pointerEvents="none"
      transform="translate(90 -94) rotate(4)"
    >
      <rect
        x="0"
        y="0"
        width="67"
        height="67"
        rx="13.34"
        fill="#fff"
        stroke="#FFA511"
        strokeMiterlimit="10"
        strokeWidth="4"
      />
      <image
        width="54"
        height="54"
        transform="translate(6.5 6.5)"
        href={getPictureByUrl(resources[4]?.link)}
        onError={onFaviconError}
        pointerEvents="all"
      />
    </g>
  );

  const resource6SVGComponent = (
    <g
      className="icon-link"
      pointerEvents="none"
      transform="translate(185 -94) rotate(14)"
    >
      <rect
        x="0"
        y="0"
        width="67"
        height="67"
        rx="13.34"
        fill="#fff"
        stroke="#FFA511"
        strokeMiterlimit="10"
        strokeWidth="4"
      />
      <image
        width="54"
        height="54"
        transform="translate(6.5 6.5)"
        href={getPictureByUrl(resources[5]?.link)}
        onError={onFaviconError}
        pointerEvents="all"
      />
    </g>
  );

  return (
    <g className="digital-resources-science" transform="translate(760, 230)">
      <defs>
        <radialGradient
          id="befcad33-8cde-4be0-a702-bbe8e7b84773"
          data-name="grad-15"
          cx="220.87"
          cy="88.5"
          r="151.42"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#fff" />
          <stop offset="1" stopColor="#f15a24" />
        </radialGradient>
        <radialGradient
          id="b6ad9256-b07b-4d0f-9623-3c02f97c36c3"
          data-name="grad-13"
          cx="141.37"
          cy="52.51"
          r="35.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#fff" />
          <stop offset="1" stopColor="#006837" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          id="a9769b35-5270-4f74-8018-0eba7461bd0a"
          data-name="grad-2"
          cx="390.92"
          cy="124.15"
          r="3.12"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#fff" stopOpacity="0.3" />
          <stop offset="0.51" stopColor="#7fff7f" stopOpacity="0.65" />
          <stop offset="1" stopColor="lime" />
        </radialGradient>
        <radialGradient
          id="a878b084-3e9a-46c2-8f22-e9fc1e31bcad"
          data-name="grad-3"
          cx="382.22"
          cy="125.53"
          r="2.19"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#fff" stopOpacity="0.5" />
          <stop offset="0.13" stopColor="#f7d1df" stopOpacity="0.6" />
          <stop offset="0.38" stopColor="#e87fa5" stopOpacity="0.77" />
          <stop offset="0.62" stopColor="#dd447c" stopOpacity="0.9" />
          <stop offset="0.84" stopColor="#d62163" stopOpacity="0.97" />
          <stop offset="1" stopColor="#d4145a" />
        </radialGradient>
        <radialGradient
          id="b8994e3d-b6db-42b8-ba7b-608bd3fe8474"
          data-name="grad-58"
          cx="368.48"
          cy="370.47"
          r="18.85"
          gradientTransform="translate(0 -205.65) scale(1 0.87)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#2e3192" />
          <stop offset="0.37" stopColor="#184fa6" stopOpacity="0.72" />
          <stop offset="0.74" stopColor="#0768b6" stopOpacity="0.49" />
          <stop offset="0.95" stopColor="#0071bc" stopOpacity="0.4" />
        </radialGradient>
        <radialGradient
          id="b62e1fe7-c181-4dc4-b209-03b1212cbbaf"
          data-name="grad-86"
          cx="368.48"
          cy="37.16"
          r="20.33"
          gradientTransform="matrix(-0.01, -0.87, 2.15, -0.03, 294, 438.13)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.21" stopColor="#008b78" />
          <stop offset="0.39" stopColor="#00a293" stopOpacity="0.84" />
          <stop offset="0.77" stopColor="#00ded8" stopOpacity="0.43" />
          <stop offset="0.95" stopColor="aqua" stopOpacity="0.2" />
        </radialGradient>
        <radialGradient
          id="b918b425-4dde-48e6-b76c-d34eae1c62de"
          cx="267.71"
          cy="375.84"
          r="16.37"
          gradientTransform="matrix(-1.3, -0.18, 0.06, -1.01, 691.23, 529.98)"
          xlinkHref="#b8994e3d-b6db-42b8-ba7b-608bd3fe8474"
        />
      </defs>
      <g id="e07ecb3c-384c-424f-8b85-c35fea50d319" data-name="science">
        <g>
          <polygon
            points="196.51 904.07 207.48 318.87 239.02 318.87 251.36 919.43 196.51 919.43 196.51 904.07"
            fill="#edc9b0"
          />
          <g>
            <polygon
              points="214.87 412 208.87 412 210.87 371 214.87 371 214.87 412"
              fill="#eab82f"
            />
            <polygon
              points="214.87 467 208.87 467 210.87 426 214.87 426 214.87 467"
              fill="#eab82f"
            />
            <polygon
              points="214.87 520 208.87 520 210.87 479 214.87 479 214.87 520"
              fill="#eab82f"
            />
            <polygon
              points="213.87 573 207.87 573 209.87 532 213.87 532 213.87 573"
              fill="#eab82f"
            />
          </g>
          <path
            d="M447.87,138.83c0,28.36-69.07,52.24-163.27,59.55-39,43.18-24.28,102.55-24.28,102.55H185.13c17.61-47-1.09-81.31-21-102.48C69.47,191.21,0,167.27,0,138.83,0,104.68,100.26,77,223.94,77S447.87,104.68,447.87,138.83Z"
            fill="#edc9b0"
          />
          <path
            d="M232.69,197.9c6.37,25.45-6.07,60.43-40.58,63.94,0,0,1.67,3.84-.51,12.58-1.57,6.32,42.48,13.38,67.06,16.82-2.33-18.59-3.44-60.32,25.94-92.86q14.49-1.12,28.13-2.76h0Z"
            fill="#53326b"
            opacity="0.21"
          />
          <polygon
            points="222.76 924.68 251.35 924.68 239.7 357.89 224.81 373.05 222.76 924.68"
            fill="#53326b"
            opacity="0.21"
          />
          <path
            d="M447.87,138.83c0-4.69-1.9-9.25-5.48-13.64,0,0-35.34,62.53-209.7,63.8-124.84.91-173.27-8.62-190.71-14.1,29.41,11.3,72.26,19.75,122.11,23.56.81.86,1.61,1.74,2.41,2.64,36.37,1.4,78.67,2,114.51,1.51q1.71-2.13,3.59-4.22C378.8,191.07,447.87,167.19,447.87,138.83Z"
            fill="#53326b"
            opacity="0.21"
          />
          <circle cx="225.31" cy="314.07" r="63.76" fill="#edc9b0" />
          <path
            d="M232.85,250.76s56.22,99-58.18,102.05a63.76,63.76,0,1,0,58.18-102.05Z"
            fill="#53326b"
            opacity="0.21"
          />
          <path
            d="M42,102.78c-26.42,10.15-42,22.6-42,36.05,0,15.12,19.63,29,52.23,39.71-9.42-8-20.19-17.23-30.8-26.46C-7.84,126.63,42,102.78,42,102.78Z"
            fill="#f2c2a0"
          />
          <ellipse
            cx="225.37"
            cy="132.01"
            rx="172.5"
            ry="36"
            fill="#53326b"
            opacity="0.21"
          />
          <path
            d="M415.87,141c0,19.88-87.3,36-195,36s-195-16.12-195-36c0,0,.2-1.06.67-3C31.48,117.68,66.59.92,220.87,0,375.33-.9,410.34,117.63,415.21,138a0,0,0,0,1,0,0C415.68,140,415.87,141,415.87,141Z"
            opacity="0.39"
            fill="url(#befcad33-8cde-4be0-a702-bbe8e7b84773)"
          />
          <circle
            cx="141.37"
            cy="52.51"
            r="35.5"
            opacity="0.5"
            fill="url(#b6ad9256-b07b-4d0f-9623-3c02f97c36c3)"
            style={{ mixBlendMode: 'soft-light' }}
          />
          <g>
            <g>
              <ellipse
                cx="368.7"
                cy="136.36"
                rx="23.86"
                ry="4.86"
                fill="#7f4896"
              />
              <path
                d="M398.16,117.24V124c0,.61-.63,1.2-1.78,1.75-4.12,1.94-15,3.33-27.68,3.33s-23.56-1.39-27.69-3.33c-1.15-.55-1.78-1.14-1.78-1.75v-6.72c0,1.29,2.78,2.47,7.38,3.36a123.53,123.53,0,0,0,22.09,1.72,123.61,123.61,0,0,0,22.09-1.72C395.38,119.71,398.16,118.53,398.16,117.24Z"
                fill="#9fb8ad"
              />
              <path
                d="M398,115.75v6.72c0,.61-.63,1.2-1.78,1.74-4.12,2-15,3.34-27.68,3.34s-23.56-1.39-27.69-3.34c-1.15-.54-1.78-1.13-1.78-1.74v-6.72c0,1.28,2.79,2.46,7.38,3.36a123.66,123.66,0,0,0,22.09,1.71,123.74,123.74,0,0,0,22.09-1.71C395.23,118.21,398,117,398,115.75Z"
                fill="#9fb8ad"
              />
              <path
                d="M398,117.75v4.72c0,.61-.63,1.2-1.78,1.74-4.12,2-15,3.34-27.68,3.34s-23.56-1.39-27.69-3.34a3.63,3.63,0,0,1-1.63-1.23v1c0,.61.63,1.2,1.78,1.75,4.13,1.94,15,3.33,27.69,3.33s23.56-1.39,27.68-3.33c1.15-.55,1.78-1.14,1.78-1.75v-6.72A1,1,0,0,1,398,117.75Z"
                fill="#434c68"
                opacity="0.56"
                style={{ mixBlendMode: 'multiply' }}
              />
              <path
                d="M398,115.89c0,1.29-2.78,2.47-7.37,3.37A123.74,123.74,0,0,1,368.55,121a123.66,123.66,0,0,1-22.09-1.71c-4.59-.9-7.38-2.08-7.38-3.37,0-2.8,13.19-5.07,29.47-5.07S398,113.09,398,115.89Z"
                fill="#c5d7bd"
              />
              <image
                width="80"
                height="78"
                transform="translate(350.87 85.01)"
                xlinkHref="data:image/png;base64,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"
              />
              <path
                d="M392.53,117.69c0,1-2.25,2-6,2.72a115.5,115.5,0,0,1-35.73,0c-3.71-.73-6-1.68-6-2.72,0-2.27,10.67-4.11,23.84-4.11S392.53,115.42,392.53,117.69Z"
                fill="#434c68"
                style={{ mixBlendMode: 'multiply' }}
              />
              <path
                d="M383.86,119c0,.67-1.43,1.27-3.79,1.73a73.07,73.07,0,0,1-22.74,0c-2.37-.46-3.8-1.06-3.8-1.73,0-1.44,6.79-2.61,15.17-2.61S383.86,117.59,383.86,119Z"
                fill="#9fb8ad"
                stroke="#efe922"
                strokeMiterlimit="10"
                strokeWidth="0.07"
              />
              <path
                d="M381.21,119c0,.55-1.19,1-3.14,1.43a60.56,60.56,0,0,1-18.75,0c-1.95-.38-3.14-.88-3.14-1.43,0-1.19,5.61-2.15,12.52-2.15S381.21,117.84,381.21,119Z"
                fill="#383e56"
                stroke="#efe922"
                strokeMiterlimit="10"
                strokeWidth="0.3"
              />
              <path
                d="M379.1,119c0,.46-1,.87-2.61,1.19a50.94,50.94,0,0,1-15.59,0c-1.62-.32-2.6-.73-2.6-1.19,0-1,4.65-1.79,10.4-1.79S379.1,118,379.1,119Z"
                fill="#9fb8ad"
                stroke="#efe922"
                strokeMiterlimit="10"
                strokeWidth="0.07"
              />
              <path
                d="M376.87,119c0,.36-.77.69-2,.93a39.45,39.45,0,0,1-12.27,0c-1.27-.24-2-.57-2-.93,0-.78,3.66-1.41,8.18-1.41S376.87,118.25,376.87,119Z"
                fill="#383e56"
                stroke="#efe922"
                strokeMiterlimit="10"
                strokeWidth="0.3"
              />
              <path
                d="M387.18,123.36v3.14s5.38-.6,7.47-1.72v-3A32.43,32.43,0,0,1,387.18,123.36Z"
                fill="url(#a9769b35-5270-4f74-8018-0eba7461bd0a)"
              />
              <image
                width="78"
                height="77"
                transform="translate(342.87 87.01)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAE4AAABNCAYAAAAIPlKzAAAACXBIWXMAAAsSAAALEgHS3X78AAAEc0lEQVR4Xu2asW7bMBCGf7YaaiQBmiG7UWTLmGfp+/AFM2bL4LXI0AJN0A5u2UE66UQdJfrKo1OUH2BEomiD9/lIU6e4EAIap/Nuq0NDpolT0sQpaeKUNHFKmjglTZySJk5JE6ekiVPSxClp4pQ0cUqaOCVNnJImTkm31aEazrmtLgCAN1J5dWcdR66sFGcc/HnE/a0wicqB1BWXLyzulz/ISgHVE7cuLbrmhS6ztvVBVwjKXly2MB9dehyu3QkD9PwkHYBhcLbi0tIEYY9rghlcpOcX5ECMArQTJ0vLFPYctd0kBkkSPTUs+xkFWFPccO6H01hYLGuNWOSGQIMgbcStSuPCYlnfh/P7eTMehr9X0WC5wJk888wrL+5kaZKsr9FnXLNBShJJ4Iq8woFWulf1SEu7B/DJ9bLoNXBHB/zap+E9390knT5vNv3n8vP3kFmUzbisbIulkaiX6b23WPJEB5dswNehz0DKPp55HjDMugriPLKl3QI4/hja9tOn4AB0u36gC4FcXr0pa1kdiSSuSCNhRwDYA8dXB7xOb+32AUc44ND77HYBTy+ul/fVYZTz7Hp5j07eOJej3BonriEe8j5NkIY9cLxxvbSI42vffrwZ+v3o3zdOb1rzYjywvO8tQjlxcxKDpWwDxqBHaYOw3z+d+CKOr5O8Ef4rLP5QTBT6kbASB3ltA2ZB7gVpxK+PDr8+TudcIPVfZF09yojL/hajbAOW0mJh8fnIftmUnq7FKSMuiygoyrZcSN5s2tJaRySzLvOLzaeiuBV4tvG2eH3j0Fo3csI6VwAjcZ4dC+vbLTBb22JSssQpC3aHUQ8jcZl0F/Je692H0/Zgj1sdymMkzrNjXsG4Zrv/A1YheVzi+2/TcUr6DLtNsJG4DOgWCpjkcDG8PcmBHdOtFyAUPosLrCguqqWlsi6WR23UzmV2uzDdu6bwWx1UlBEn3jj7ZdOYEazCQVMunpL8RVCf7iJM0nm1JC502lFGXBJaY4R1DgAOu14AlydNT95OfWfZJk3TxPpWqDpiJS4xuKuwyLoukgdMomKRo7QvYfYZSTxgsL4BJcUlp+ta1l32WTPKew7oLtIvHHppTwCepHocYfdrSljW4wLEW52rADw44D70G+LLoba2C/3G+MtUMQEwL2LuhraUNP7leMCoiAlUqQADeVVg4iW6/4SibA78W+KAFXmfhXtJ/oQrFpiC/xBImWb/vAGwnaoRd2HKupvQy6PAHxzGQNfqamuPBgEmzZzyGQec+BRfeoIf19Wk/VnyYTRgnG2AlThgRR6QfhaR828Q5//3B6CuuPFK/8cPp9qa2YawsdUmQDtxQIY8YL4mbUnk+zPPL1SVBliLA7aeR0TXvNhpjucn6cEbB2Yvjth+oCNc9xBkrg+4UkD1xAE58v6OisHUFUeUFniGIM4jjqOVeOaBn19cChL6Rgf4dsW9ccrV4/4zmjglTZySJk5JE6ekiVPSxClp4pQ0cUqaOCVNnJImTkkTp6SJU9LEKfkDSMo+Mf32jFIAAAAASUVORK5CYII="
              />
              <path
                d="M344.83,117.69c1.46.13,2.9.35,4.35.56s2.89.47,4.32.78c-1.46-.13-2.91-.35-4.35-.56S346.26,118,344.83,117.69Z"
                fill="#1ef9aa"
              />
              <path
                d="M349.16,115.33c.86.43,1.68.93,2.5,1.42s1.61,1,2.38,1.61c-.87-.43-1.68-.93-2.5-1.42S349.93,115.92,349.16,115.33Z"
                fill="#1ef9aa"
              />
              <path
                d="M354,114.45a18.91,18.91,0,0,1,2.8,3,15.11,15.11,0,0,1-1.48-1.4A17.71,17.71,0,0,1,354,114.45Z"
                fill="#1ef9aa"
              />
              <path
                d="M358.36,114a10.45,10.45,0,0,1,.63,1.41,10.07,10.07,0,0,1,.41,1.48,10.45,10.45,0,0,1-.63-1.41A11.49,11.49,0,0,1,358.36,114Z"
                fill="#1ef9aa"
              />
              <path
                d="M361.76,113.76a10,10,0,0,1,.36,1.43,9,9,0,0,1,.14,1.47,10,10,0,0,1-.36-1.43A9,9,0,0,1,361.76,113.76Z"
                fill="#1ef9aa"
              />
              <path
                d="M364.75,113.64a8.53,8.53,0,0,1,.11,1.43,8.73,8.73,0,0,1-.11,1.44,8.73,8.73,0,0,1-.11-1.44A8.53,8.53,0,0,1,364.75,113.64Z"
                fill="#1ef9aa"
              />
              <path
                d="M367.34,113.64a8.14,8.14,0,0,1,.11,1.39,8.26,8.26,0,0,1-.11,1.4,8.26,8.26,0,0,1-.11-1.4A8.14,8.14,0,0,1,367.34,113.64Z"
                fill="#1ef9aa"
              />
              <path
                d="M370.33,113.64a9.32,9.32,0,0,1,0,1.4,8.27,8.27,0,0,1-.25,1.39,9.46,9.46,0,0,1,0-1.41A8.16,8.16,0,0,1,370.33,113.64Z"
                fill="#1ef9aa"
              />
              <path
                d="M372.65,113.64a10,10,0,0,1-.63,2.84,7.92,7.92,0,0,1,.21-1.45A8.55,8.55,0,0,1,372.65,113.64Z"
                fill="#1ef9aa"
              />
              <path
                d="M375.64,113.76a10,10,0,0,1-.44,1.41,8.45,8.45,0,0,1-.64,1.32,9.13,9.13,0,0,1,1.08-2.73Z"
                fill="#1ef9aa"
              />
              <path
                d="M378,113.91a11.49,11.49,0,0,1-1.61,2.73,11.49,11.49,0,0,1,1.61-2.73Z"
                fill="#1ef9aa"
              />
              <path
                d="M381.09,114.18a12.57,12.57,0,0,1-1,1.41,14,14,0,0,1-1.15,1.28,12.69,12.69,0,0,1,1-1.42A13.87,13.87,0,0,1,381.09,114.18Z"
                fill="#1ef9aa"
              />
              <path
                d="M383.86,114.52a22,22,0,0,1-3.31,2.88,20.58,20.58,0,0,1,1.58-1.52A18.8,18.8,0,0,1,383.86,114.52Z"
                fill="#1ef9aa"
              />
              <path
                d="M386.88,115c-.67.57-1.4,1.06-2.12,1.56s-1.47,1-2.25,1.36c.68-.56,1.41-1,2.13-1.55S386.1,115.44,386.88,115Z"
                fill="#1ef9aa"
              />
              <path
                d="M390.23,115.92c-1,.61-2.07,1.13-3.12,1.66s-2.12,1-3.21,1.45c1-.6,2.06-1.12,3.11-1.65S389.13,116.36,390.23,115.92Z"
                fill="#1ef9aa"
              />
              <path
                d="M391.22,119c-1.34.23-2.7.37-4.05.52s-2.71.26-4.07.31c1.34-.23,2.69-.38,4-.53S389.86,119.08,391.22,119Z"
                fill="#1ef9aa"
              />
              <path
                d="M383.1,121a2.24,2.24,0,0,1-.74-.19,2.39,2.39,0,0,1-.65-.39,2.31,2.31,0,0,1,.74.19A2.44,2.44,0,0,1,383.1,121Z"
                fill="#1ef9aa"
              />
              <path
                d="M348.45,119.86c.93-.1,1.86-.1,2.79-.12s1.86,0,2.8.12c-.94.09-1.87.09-2.8.11S349.38,120,348.45,119.86Z"
                fill="#1ef9aa"
              />
              <path
                d="M354.72,121a2.17,2.17,0,0,1,.69-.36,2.2,2.2,0,0,1,.77-.15,3,3,0,0,1-.69.36A2.77,2.77,0,0,1,354.72,121Z"
                fill="#1ef9aa"
              />
              <path
                d="M396.41,125.86l-1.87,1.81-6.77,6.56c0,1.81-8.57,3.24-19.11,3.18s-19.07-1.58-19.06-3.4l-6.26-6.19-2.3-2.27c4.12,2,14.95,3.42,27.67,3.49S392.28,127.78,396.41,125.86Z"
                fill="#434c68"
              />
              <path
                d="M379.64,124.19v3.06a28,28,0,0,0,5.15-.38v-3.06A30.58,30.58,0,0,1,379.64,124.19Z"
                fill="url(#a878b084-3e9a-46c2-8f22-e9fc1e31bcad)"
              />
              <path
                d="M387.77,134.23l.32-.32c-18.62,2.28-31.33,1.17-38.8-.2l.31.3c0,1.82,8.52,3.34,19.06,3.4S387.76,136,387.77,134.23Z"
                fill="#434c68"
                style={{ mixBlendMode: 'multiply' }}
              />
              <ellipse
                cx="368.48"
                cy="116.62"
                rx="27.96"
                ry="5.67"
                strokeMiterlimit="10"
                strokeWidth="0.07"
                opacity="0.76"
                fill="url(#b8994e3d-b6db-42b8-ba7b-608bd3fe8474)"
                stroke="url(#b62e1fe7-c181-4dc4-b209-03b1212cbbaf)"
                style={{ mixBlendMode: 'color-dodge' }}
              />
            </g>
            <path
              d="M402.15,84.41c0,3.7-16.88,36.69-33.5,36.69s-35.1-33.78-35.1-37.49S352,90,368.65,90,402.15,80.71,402.15,84.41Z"
              opacity="0.76"
              fill="url(#b918b425-4dde-48e6-b76c-d34eae1c62de)"
              style={{ mixBlendMode: 'color-dodge' }}
            />
            <g>
              <g>
                <circle cx="368.94" cy="64.91" r="4.1" fill="#d62e16" />
                <ellipse
                  cx="368.27"
                  cy="64.53"
                  rx="7.3"
                  ry="18.55"
                  transform="matrix(0.84, -0.54, 0.54, 0.84, 22.65, 207.12)"
                  fill="none"
                  stroke="#a2dcfb"
                  strokeMiterlimit="10"
                  strokeWidth="0.92"
                />
                <ellipse
                  cx="368.27"
                  cy="64.53"
                  rx="18.55"
                  ry="7.3"
                  transform="translate(4.86 152.41) rotate(-23.53)"
                  fill="none"
                  stroke="#7edef6"
                  strokeMiterlimit="10"
                  strokeWidth="0.92"
                />
                <circle cx="380.77" cy="64.76" r="1.62" fill="#e8ff3c" />
                <circle cx="357.23" cy="54.61" r="1.62" fill="#81e536" />
              </g>
              <g>
                <ellipse
                  cx="368.12"
                  cy="65.4"
                  rx="43.75"
                  ry="22.6"
                  fill="none"
                  stroke="#605cd4"
                  strokeMiterlimit="10"
                  strokeWidth="7.29"
                />
                <image
                  width="168"
                  height="126"
                  transform="translate(283.87 1.01)"
                  xlinkHref="data:image/png;base64,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"
                />
                <ellipse
                  cx="368.12"
                  cy="65.4"
                  rx="43.75"
                  ry="22.6"
                  fill="none"
                  stroke="#e1e1ef"
                  strokeMiterlimit="10"
                  strokeWidth="1.46"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
      <g className="text" transform="translate(-160 -60)">
        <path
          d="M344.8,230.65a.88.88,0,0,0-.52-.35,9.16,9.16,0,0,0-2.42-.3.55.55,0,0,0-.43.17,1,1,0,0,0-.2.32l-.12.52-.83-.06-.84,0a17.19,17.19,0,0,0-3.13.29,10.48,10.48,0,0,0-2.77.91,5.68,5.68,0,0,0-2,1.57,3.52,3.52,0,0,0-.76,2.27,3.13,3.13,0,0,0,.68,2.09,5,5,0,0,0,1.67,1.3,9.92,9.92,0,0,0,2.19.76c.79.17,1.52.31,2.19.43s1.22.23,1.67.34.68.27.68.47a.77.77,0,0,1-.33.63,2.59,2.59,0,0,1-.85.42,7.18,7.18,0,0,1-1.19.23,12.22,12.22,0,0,1-1.35.08,9.54,9.54,0,0,1-1.19-.06l-.77-.09-.4-.09a1.6,1.6,0,0,0-.32,0,.53.53,0,0,0-.39.14.79.79,0,0,0-.17.38c-.05.27-.09.55-.12.86a8.77,8.77,0,0,0,0,.88v.41a2.42,2.42,0,0,0,0,.45.72.72,0,0,0,.23.36.92.92,0,0,0,.52.22,18.71,18.71,0,0,0,2.79.23,13.29,13.29,0,0,0,3.11-.34,8.32,8.32,0,0,0,2.48-1,5.22,5.22,0,0,0,1.65-1.62,4.05,4.05,0,0,0,.61-2.19,3.51,3.51,0,0,0-.64-2.18,4.64,4.64,0,0,0-1.6-1.31,8.68,8.68,0,0,0-2.08-.73c-.76-.17-1.45-.31-2.09-.42a13.42,13.42,0,0,1-1.59-.38c-.43-.13-.64-.35-.64-.63a.69.69,0,0,1,.27-.52,2.17,2.17,0,0,1,.73-.39,6.81,6.81,0,0,1,1.1-.23,9.54,9.54,0,0,1,1.37-.09l.85,0,.89.09,0,.52c0,.17,0,.34,0,.51a.83.83,0,0,0,.14.47.51.51,0,0,0,.39.28,7.59,7.59,0,0,0,1,.18c.32,0,.72,0,1.22,0a.85.85,0,0,0,.62-.2.91.91,0,0,0,.24-.49c.07-.36.13-.71.19-1.05s.11-.7.16-1.07.09-.76.12-1.18.06-.89.09-1.41A.72.72,0,0,0,344.8,230.65Z"
          fill="#fff"
        />
        <path
          d="M356.94,244.25c0-.11-.07-.23-.11-.36s-.17-.36-.26-.54-.18-.33-.28-.49-.35-.41-.56-.41a.83.83,0,0,0-.31.08l-.43.18a4.31,4.31,0,0,1-.51.22c-.2.08-.42.16-.65.23a6.25,6.25,0,0,1-.72.17,4.13,4.13,0,0,1-.66.07,2.92,2.92,0,0,1-1.13-.21l-.26-.12a2.56,2.56,0,0,1-.59-.43,2.28,2.28,0,0,1-.53-.8,2.45,2.45,0,0,1-.19-1,2,2,0,0,1,.25-1,2.46,2.46,0,0,1,.66-.78,3.38,3.38,0,0,1,1-.55,4.35,4.35,0,0,1,1.2-.26c0,.13,0,.26,0,.4a2.35,2.35,0,0,0,0,.26,6.07,6.07,0,0,0,.07.63,1.17,1.17,0,0,0,1.05,1,7.58,7.58,0,0,0,1.26.09,1.06,1.06,0,0,0,.66-.16,1.34,1.34,0,0,0,.27-.62,8.2,8.2,0,0,0,.14-1.5c0-.2,0-.41,0-.62s0-.42-.07-.65a1.47,1.47,0,0,0-.3-.86,2,2,0,0,0-.77-.45,4.26,4.26,0,0,0-1-.25,1.13,1.13,0,0,0-.18,0,8.69,8.69,0,0,0-3.77.35,7.93,7.93,0,0,0-2.28,1.17,6,6,0,0,0-1.6,1.79,4.29,4.29,0,0,0-.61,2.24,7,7,0,0,0,.08.92,4.76,4.76,0,0,0,.33,1.13,5.5,5.5,0,0,0,.68,1.18,4.35,4.35,0,0,0,1.18,1.06,6.74,6.74,0,0,0,1.79.75h0a10.08,10.08,0,0,0,2.5.28,7.26,7.26,0,0,0,1.22-.1,8,8,0,0,0,1.2-.27,7.44,7.44,0,0,0,1.07-.39,4.15,4.15,0,0,0,.84-.51.87.87,0,0,0,.37-.62A.77.77,0,0,0,356.94,244.25Z"
          fill="#fff"
        />
        <path
          d="M362.59,235.92c0-.1-.2-.16-.43-.18l-.37,0h-.4l-1,0a5.77,5.77,0,0,0-.9.12.64.64,0,0,0-.58.4,3.48,3.48,0,0,0-.14.83c-.06.84-.11,1.67-.14,2.47s0,1.61,0,2.43c0,.5,0,1,0,1.51s0,1,.07,1.54a1.52,1.52,0,0,0,.25.81,1.24,1.24,0,0,0,.91.33,10.86,10.86,0,0,0,1.28.07,2.39,2.39,0,0,0,.68-.07.74.74,0,0,0,.36-.2.66.66,0,0,0,.16-.37,3.69,3.69,0,0,0,.06-.55c.11-1.43.18-2.82.22-4.16s.06-2.77.06-4.31A1.94,1.94,0,0,0,362.59,235.92Zm.37-4.22a1.32,1.32,0,0,0-.42-.68,1.63,1.63,0,0,0-.74-.33,5.78,5.78,0,0,0-1.11-.09,2.51,2.51,0,0,0-1.78.51,2,2,0,0,0-.52,1.53,4.15,4.15,0,0,0,.11,1,1.39,1.39,0,0,0,.39.64,1.48,1.48,0,0,0,.71.35,5.56,5.56,0,0,0,1.09.09,4.12,4.12,0,0,0,1.2-.14,1.55,1.55,0,0,0,.73-.4,1.42,1.42,0,0,0,.37-.61,2.64,2.64,0,0,0,.1-.76A4,4,0,0,0,363,231.7Z"
          fill="#fff"
        />
        <path
          d="M375.77,238.92a5.32,5.32,0,0,0-1-1.61A5.45,5.45,0,0,0,373,236a6.15,6.15,0,0,0-2.71-.54,6.58,6.58,0,0,0-2.29.41,6.13,6.13,0,0,0-2,1.15,5.84,5.84,0,0,0-1.34,1.77,5.19,5.19,0,0,0-.5,2.26,5,5,0,0,0,.49,2.22,5.49,5.49,0,0,0,3.16,2.79,6.29,6.29,0,0,0,2.2.39,10.08,10.08,0,0,0,2.85-.38,5.12,5.12,0,0,0,2-1,1,1,0,0,0,.37-.73v-.2a.74.74,0,0,0-.05-.23c0-.16-.06-.31-.1-.47A3.68,3.68,0,0,0,375,243a1.91,1.91,0,0,0-.19-.36.34.34,0,0,0-.28-.12,1.77,1.77,0,0,0-.49.15,7.22,7.22,0,0,1-1.49.47,8.1,8.1,0,0,1-1.42.16,4.27,4.27,0,0,1-1.55-.29,3.44,3.44,0,0,1-1.2-.79c.62,0,1.27-.07,1.95-.14s1.33-.14,1.95-.22,1.23-.19,1.79-.3a14.27,14.27,0,0,0,1.42-.37.86.86,0,0,0,.46-.34,1,1,0,0,0,.12-.48A4.63,4.63,0,0,0,375.77,238.92Zm-5.63,1c-.77.06-1.51.1-2.21.13a2.29,2.29,0,0,1,1-1.14,2.72,2.72,0,0,1,1.51-.45,2.4,2.4,0,0,1,1.08.27,1.6,1.6,0,0,1,.8.89A16,16,0,0,1,370.14,239.89Z"
          fill="#fff"
        />
        <path
          d="M388.36,236.85a2.61,2.61,0,0,0-.94-.93,3.59,3.59,0,0,0-1.18-.4,6.59,6.59,0,0,0-1.1-.1,6.94,6.94,0,0,0-2,.28,6.32,6.32,0,0,0-1.83.84c0-.12,0-.22,0-.31a2.62,2.62,0,0,0,0-.27.63.63,0,0,0-.11-.41.57.57,0,0,0-.47-.15l-.67,0-.79.05-.77.08a4.59,4.59,0,0,0-.65.11c-.31.07-.5.21-.55.44a4.18,4.18,0,0,0-.11.82c0,.26,0,.52,0,.78v.77c0,1.12,0,2.24.12,3.37s.18,2.23.3,3.32a1.48,1.48,0,0,0,.29.77,1.32,1.32,0,0,0,.94.31l.35,0H380l.36,0a2,2,0,0,0,1-.24.68.68,0,0,0,.24-.56,1.7,1.7,0,0,0,0-.22,2.23,2.23,0,0,0,0-.23c-.09-.91-.16-1.81-.22-2.71s-.08-1.82-.08-2.75a5.75,5.75,0,0,1,1.33-.64,4.32,4.32,0,0,1,1.23-.2.76.76,0,0,1,.67.31,1.46,1.46,0,0,1,.22.83c0,.89,0,1.63,0,2.23s-.05,1.11-.09,1.51-.07.72-.09,1a4.59,4.59,0,0,0,0,.59.85.85,0,0,0,.75.94,8.75,8.75,0,0,0,1.08.16c.38,0,.69.06.92.06A.85.85,0,0,0,388,246a1.81,1.81,0,0,0,.22-.68q.14-.94.24-1.92c.07-.64.13-1.26.17-1.85s.07-1.16.09-1.67,0-1,0-1.36A3,3,0,0,0,388.36,236.85Z"
          fill="#fff"
        />
        <path
          d="M401.08,244.25c0-.11-.07-.23-.11-.36s-.17-.36-.26-.54-.19-.33-.28-.49a.71.71,0,0,0-.56-.41.83.83,0,0,0-.31.08l-.43.18a4.31,4.31,0,0,1-.51.22c-.21.08-.42.16-.66.23a5.65,5.65,0,0,1-.71.17,4.13,4.13,0,0,1-.66.07,2.88,2.88,0,0,1-1.13-.21,2.5,2.5,0,0,1-.85-.55,2.28,2.28,0,0,1-.53-.8,2.45,2.45,0,0,1-.19-1,2.07,2.07,0,0,1,.24-1,2.62,2.62,0,0,1,.67-.78,3.38,3.38,0,0,1,1-.55,4.35,4.35,0,0,1,1.2-.26c0,.22,0,.43,0,.66a6.07,6.07,0,0,0,.07.63,1.17,1.17,0,0,0,1.05,1,7.54,7.54,0,0,0,1.25.09,1.07,1.07,0,0,0,.67-.16,1.25,1.25,0,0,0,.26-.62,7.41,7.41,0,0,0,.14-1.5c0-.2,0-.41,0-.62s0-.42-.07-.65a1.62,1.62,0,0,0-.3-.86,2,2,0,0,0-.77-.45,4.77,4.77,0,0,0-1.19-.28,8.69,8.69,0,0,0-3.77.35,7.93,7.93,0,0,0-2.28,1.17,6.22,6.22,0,0,0-1.61,1.79,4.37,4.37,0,0,0-.6,2.24,7,7,0,0,0,.08.92,4.76,4.76,0,0,0,.33,1.13,5.5,5.5,0,0,0,.68,1.18,4.35,4.35,0,0,0,1.18,1.06,6.74,6.74,0,0,0,1.79.75,9.84,9.84,0,0,0,2.53.29,7.26,7.26,0,0,0,1.22-.1,8,8,0,0,0,1.2-.27,7.44,7.44,0,0,0,1.07-.39,4.8,4.8,0,0,0,.84-.51.87.87,0,0,0,.37-.62A.77.77,0,0,0,401.08,244.25Z"
          fill="#fff"
        />
        <path
          d="M413.6,238.92a5.32,5.32,0,0,0-1-1.61,5.45,5.45,0,0,0-1.77-1.31,6.12,6.12,0,0,0-2.71-.54,6.62,6.62,0,0,0-2.29.41,6.13,6.13,0,0,0-1.95,1.15,6,6,0,0,0-1.34,1.77,5.19,5.19,0,0,0-.49,2.26,5,5,0,0,0,.48,2.22,5.57,5.57,0,0,0,3.16,2.79,6.29,6.29,0,0,0,2.2.39,10.08,10.08,0,0,0,2.85-.38,5,5,0,0,0,2-1,.92.92,0,0,0,.37-.73v-.2a.74.74,0,0,0-.05-.23c0-.16-.06-.31-.1-.47a3.68,3.68,0,0,0-.15-.47,1.91,1.91,0,0,0-.19-.36.32.32,0,0,0-.28-.12,1.77,1.77,0,0,0-.49.15,7.22,7.22,0,0,1-1.49.47,8,8,0,0,1-1.42.16,4.27,4.27,0,0,1-1.55-.29,3.39,3.39,0,0,1-1.19-.79c.62,0,1.26-.07,1.94-.14s1.33-.14,2-.22,1.23-.19,1.79-.3a14.27,14.27,0,0,0,1.42-.37.86.86,0,0,0,.46-.34,1,1,0,0,0,.12-.48A4.63,4.63,0,0,0,413.6,238.92Zm-5.63,1c-.77.06-1.51.1-2.21.13a2.29,2.29,0,0,1,1-1.14,2.72,2.72,0,0,1,1.51-.45,2.4,2.4,0,0,1,1.08.27,1.65,1.65,0,0,1,.81.89A16.39,16.39,0,0,1,408,239.89Z"
          fill="#fff"
        />
      </g>
      {resources && (
        <g className="resources-wrap" transform="translate(70, 105)">
          <ResourceLink
            r={resources[0]}
            svgComponent={resource1SVGComponent}
            onElementHover={(e) =>
              onElementHover(resources[0], e.target as SVGElement)
            }
            onElementLeave={() => onElementHover()}
            onElementClick={onClick}
          />
          <ResourceLink
            r={resources[1]}
            svgComponent={resource2SVGComponent}
            onElementHover={(e) =>
              onElementHover(resources[1], e.target as SVGElement)
            }
            onElementLeave={() => onElementHover()}
            onElementClick={onClick}
          />
          <ResourceLink
            r={resources[2]}
            svgComponent={resource3SVGComponent}
            onElementHover={(e) =>
              onElementHover(resources[2], e.target as SVGElement)
            }
            onElementLeave={() => onElementHover()}
            onElementClick={onClick}
          />
          <ResourceLink
            r={resources[3]}
            svgComponent={resource4SVGComponent}
            onElementHover={(e) =>
              onElementHover(resources[3], e.target as SVGElement)
            }
            onElementLeave={() => onElementHover()}
            onElementClick={onClick}
          />
          <ResourceLink
            r={resources[4]}
            svgComponent={resource5SVGComponent}
            onElementHover={(e) =>
              onElementHover(resources[4], e.target as SVGElement)
            }
            onElementLeave={() => onElementHover()}
            onElementClick={onClick}
          />
          <ResourceLink
            r={resources[5]}
            svgComponent={resource6SVGComponent}
            onElementHover={(e) =>
              onElementHover(resources[5], e.target as SVGElement)
            }
            onElementLeave={() => onElementHover()}
            onElementClick={onClick}
          />
        </g>
      )}
    </g>
  );
};
export default ScienceLink;
